import { basemapTiles } from '../data/constants.js';

export function switchBasemap(map, style, btn) {
  document.querySelectorAll('.bm-btn').forEach(b => b.classList.remove('on'));
  btn.classList.add('on');

  map.getSource('carto').tiles = [basemapTiles[style]];
  map.style.sourceCaches['carto'].clearTiles();
  map.triggerRepaint();
  map.style.sourceCaches['carto']._update();

  // Nudge zoom to force tile re-fetch
  const z = map.getZoom();
  map.setZoom(z + 0.001);
  setTimeout(() => map.setZoom(z), 50);
}
